// Event icon registry — drives every event-type chip, bubble, badge.
import {
  Diamond, Gift, Sparkles, Flower, GraduationCap,
  Heart, Wine, Plane, Home, Star,
} from "lucide-react";

export const EVENT_ICONS = [
  { key: "wedding",      label: "Wedding",      Icon: Diamond,       color: "#9D4EDD" },
  { key: "birthday",     label: "Birthday",     Icon: Gift,          color: "#FF6B6B" },
  { key: "party",        label: "Party",        Icon: Sparkles,      color: "#FFD300" },
  { key: "baby",         label: "Baby Shower",  Icon: Flower,        color: "#FFB7C5" },
  { key: "graduation",   label: "Graduation",   Icon: GraduationCap, color: "#22E2FF" },
  { key: "anniversary",  label: "Anniversary",  Icon: Heart,         color: "#FF1F6B" },
  { key: "engagement",   label: "Engagement",   Icon: Wine,          color: "#FF7A00" },
  { key: "trip",         label: "Trip",         Icon: Plane,         color: "#22A8FF" },
  { key: "housewarming", label: "Housewarming", Icon: Home,          color: "#22FFB7" },
  { key: "other",        label: "Other",        Icon: Star,          color: "#E63DDB" },
];

export const getIconConfig = (key) =>
  EVENT_ICONS.find((e) => e.key === key) || EVENT_ICONS[EVENT_ICONS.length - 1];
